import { useEffect } from 'react';
import { FormikProvider, useField, useFormik } from 'formik';
import { useTranslation } from 'react-i18next';

import * as graphql from 'generated/graphql';

import Select from 'packages/kakapo-ui-kit/components/forms/controls/Select';
import useLocalize from 'packages/kakapo-ui-application/hooks/useLocalize';

import FilledInBy from './common/FilledInBy';
import Property from './common/Property';

function CompetencyLevelSet() {
	const { t } = useTranslation();
	const { localize } = useLocalize();
	const [field, , { setValue }] = useField<graphql.CompetencyLevelSet | undefined>(
		'competencyLevelSet',
	);

	const { data } = graphql.useCompetencyLevelSetsQuery({
		variables: {
			isArchived: false,
			first: 1000,
		},
	});

	const options =
		data?.competencyLevelSets.edges.map((edge) => ({
			value: edge.node.id,
			label: localize(edge.node.title).text,
		})) ?? [];

	const selectedOption = options.find((option) => option.value === field.value?.id);

	return (
		<Property
			title={t('common.settings.evaluationForms.properties.finalScore.competencyLevelSet.label')}
		>
			<Select
				options={options}
				value={selectedOption}
				onChange={(option) => {
					const set = data?.competencyLevelSets.edges.find(
						(edge) => edge.node.id === option?.value,
					);
					setValue(set?.node as graphql.CompetencyLevelSet);
				}}
			/>
		</Property>
	);
}

export default function ReviewGoalsModal(props: {
	fillInBy: graphql.EvaluationFillInBy;
	item: graphql.EvaluationReviewGoalsItem;
	onChange: (item: graphql.EvaluationReviewGoalsItem, fillInBy: graphql.EvaluationFillInBy) => void;
}) {
	const formik = useFormik({
		initialValues: {
			competencyLevelSet: props.item.competencyLevelSet,
			fillInBy: props.fillInBy,
		},
		onSubmit: () => {},
	});

	useEffect(() => {
		if (!formik.values.competencyLevelSet) {
			return;
		}

		props.onChange(
			{
				...props.item,
				competencyLevelSet: formik.values.competencyLevelSet,
			},
			formik.values.fillInBy,
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [formik.values.fillInBy, formik.values.competencyLevelSet?.id]);

	return (
		<FormikProvider value={formik}>
			<FilledInBy />
			<CompetencyLevelSet />
		</FormikProvider>
	);
}
